import SoundUploader from 'api/SoundUploader.js';
import Sample from 'repos/Sample.js';
import {getPatternLength} from 'engine/BouncingEngine.js';
import {crop} from 'engine/Crop.js';
import Tone from 'tone';

export const chopByPatterns = async (sequencerEngine, audioBuffer, numPatterns, tracks) => {
    let bounces = [];
    let time = 0;

    let soundUploader = new SoundUploader(
        2, (soundId, ipfsHash, loopNumber) => []);

    let loops = sequencerEngine.state.freeze.loops;
    let len = getPatternLength(sequencerEngine, 0, tracks) * loops;
    for (let patternNumber=0; patternNumber < numPatterns; patternNumber++) {
        let start = time;
        let end = start + Tone.Master.context.sampleRate * len * new Tone.Time('32n').toMilliseconds() / 1000.0;
        let cropped = crop(audioBuffer, start, end, Tone.Master.context);
        time = end;
        let ipfsHash = await soundUploader.uploadBufferToIpfs(cropped);
        let sample = new Sample(ipfsHash);
        sample.audioBuffer = cropped;
        sample.tempo = sequencerEngine.tempo;
        sample.name = 'Frozen Pattern ' + (patternNumber + 1);
        sample.tags = ['Resampled'];
        bounces.push(sample);
    }

    return bounces;
};
